const HighMiddleAges = {
  id: '12',
  name: 'High Middle Ages'
};

export default HighMiddleAges;
